import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useTimeField } from "@react-aria/datepicker";
import { useLocale } from "@react-aria/i18n";
import { useTimeFieldState } from "@react-stately/datepicker";
import { useRef } from "react";
import { Box } from "../Box/Box.mjs";
import "../Text/TextContext.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconSchedule } from "../icons/IconSchedule/IconSchedule.mjs";
import { DateSegment } from "./DateSegment.mjs";
import { Time } from "@internationalized/date";
import { Field } from "../private/Field/Field.mjs";
import { ActionField } from "../private/Field/ActionField.mjs";
import { useDefaultMessages } from "../useDefaultMessages/useDefaultMessages.mjs";
function TimeField(props) {
  var _a;
  const { locale } = useLocale();
  const { onBlur, onFocus, readOnly, id, onAction, value, ...restProps } = props;
  const { defaultMessages } = useDefaultMessages();
  const onChange = (v) => {
    if (!v) return;
    const time = new Time(v.hour, v.minute, v.second, v.millisecond);
    return props.onChange(time);
  };
  const state = useTimeFieldState({
    ...restProps,
    locale,
    value: value || void 0,
    onChange
  });
  const ref = useRef(null);
  const {
    // labelProps,
    fieldProps: fieldBehaviourProps
    // descriptionProps,
    // errorMessageProps,
  } = useTimeField(
    {
      ...restProps,
      value: props.value || void 0,
      onChange,
      onFocus: (e) => onFocus == null ? void 0 : onFocus(e)
    },
    state,
    ref
  );
  return /* @__PURE__ */ jsx(Field, { id, ...restProps, value: (_a = props.value) == null ? void 0 : _a.toString(), children: (overlays, fieldProps, icon, prefix) => /* @__PURE__ */ jsxs(Fragment, { children: [
    icon,
    prefix,
    /* @__PURE__ */ jsx(Box, { ref, ...fieldProps, display: "flex", children: /* @__PURE__ */ jsx(Box, { width: "full", display: "flex", ...fieldBehaviourProps, children: state.segments.map((segment, i) => /* @__PURE__ */ jsx(DateSegment, { segment, state, isReadonly: props.readOnly }, i)) }) }),
    overlays,
    /* @__PURE__ */ jsx(
      ActionField,
      {
        id: `${id}-action`,
        onAction,
        icon: /* @__PURE__ */ jsx(IconSchedule, {}),
        label: defaultMessages.TimeField.actionFieldLabel
      }
    )
  ] }) });
}
export {
  TimeField
};
